import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ru from 'vuetify/src/locale/ru'

import { Ripple } from 'vuetify/lib/directives'

import { normal } from '@/themes'

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
})

import '@/plugins/vuetify/base.less'

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: normal,
    },
    options: {
      customProperties: true,
    },
  },
  lang: {
    locales: { ru },
    current: 'ru',
  },
  icons: {
    iconfont: 'mdiSvg',
  },
})
